import { X } from "@boxicons/react";
import * as Dialog from "@radix-ui/react-dialog";
import * as React from "react";

import { classNames } from "$app/utils/classNames";

export const Modal = ({
  className,
  title,
  children,
  footer,
  allowClose = true,
  onClose,
  modal = true,
  usePortal = true,
  ...props
}: {
  className?: string;
  title?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  allowClose?: boolean;
  usePortal?: boolean;
  onClose?: () => void;
} & Omit<React.ComponentProps<typeof Dialog.Root>, "onOpenChange">) => {
  const content = (
    <>
      <Dialog.Content
        aria-modal={modal}
        className={classNames(
          "fixed top-[50%] left-[50%] z-51 flex max-h-[90vh] max-w-175 min-w-80 translate-[-50%] flex-col gap-4 overflow-y-auto rounded border border-border bg-background p-8 shadow-lg dark:shadow-none",
          className,
        )}
        onOpenAutoFocus={(e) => {
          if (!modal) e.preventDefault();
        }}
      >
        {title ? (
          <div className="flex items-start justify-between gap-4">
            <Dialog.Title>{title}</Dialog.Title>
            {allowClose ? (
              <Dialog.Close className="cursor-pointer text-base all-unset" aria-label="Close">
                <X className="size-5" />
              </Dialog.Close>
            ) : null}
          </div>
        ) : null}
        {children}
        {footer ? <footer className="grid gap-4 sm:flex sm:justify-end">{footer}</footer> : null}
      </Dialog.Content>
      <Dialog.Overlay className="fixed inset-0 z-50 bg-backdrop" />
    </>
  );

  return (
    <Dialog.Root onOpenChange={() => onClose?.()} modal={modal} {...props}>
      {usePortal ? <Dialog.Portal>{content}</Dialog.Portal> : content}
    </Dialog.Root>
  );
};
